import { AuthenticateService } from './../../../share/authenticate/authenticate.service';
import { Component, OnInit, Input } from '@angular/core';
import { LOADING_IMAGE } from '../../../../environments/environment';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  isDispLoadingImage = false;
  @Input() loadImgClass = 'load-img';
  @Input() loadType = 'none';
  message = '';

  constructor(
    public authServ: AuthenticateService,
  ) { }

  ngOnInit() {
    if (LOADING_IMAGE === true) {
      switch (this.loadType) {
        case 'none':
          this.message = 'データ取得中';
          break;
        case 'authenticating':
        this.message = '認証中';
          break;
        case 'createPdf':
          this.message = 'PDF作成中';
          break;
        case 'createCsv':
          this.message = 'CSV作成中';
          break;
        case 'checkItadakimasu':
          this.message = 'データ取得中。この画面が表示され続ける場合、通信環境をご確認して下さい。';
          break;
      }
      this.isDispLoadingImage = true;
    }
  }

}